import React, { PropTypes } from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import BatchActionsControls from '../BatchActionsControls';
import BatchActionsToolbar from '../BatchActionsToolbar';

import './BatchActionsList.scss';

export default class BatchActionsList extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedItems: Immutable.Map()
    };

    this.bindAll('updateItem', 'updateAll');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.list.equals(this.props.list)) {
      this.updateSelectedItemsForList(nextProps.list);
    } else {
      this.setState({ selectedItems: Immutable.Map() });
    }
  }

  updateSelectedItemsForList(list) {
    // Items in the list may have been removed or changed.
    // Remove deleted items from the list, and update existing references.
    const selectedItems = Immutable.Map().withMutations(updatedSelectedItems => {
      this.state.selectedItems.forEach((selectedItem) => {
        const updatedItem = list.find(item => selectedItem.get('id') === item.get('id'));
        if (updatedItem) {
          updatedSelectedItems.set(updatedItem.get('id'), updatedItem);
        }
      });
    });

    this.setState({ selectedItems });
  }

  updateAll(selected) {
    if (selected) {
      this.setState({
        selectedItems: this.props.list.reduce(
          (result, item) => result.set(item.get('id'), item), Immutable.Map()
        )
      });
    } else {
      this.setState({
        selectedItems: Immutable.Map()
      });
    }
  }

  updateItem(item) {
    if (typeof item.get('id') === 'undefined') {
      throw new Error('[BatchActionsList] updateItem must be called with an Immutable.Map with an `id`', item);
    }

    const isSelected = this.state.selectedItems.has(item.get('id'));
    if (isSelected) {
      return this.setState({
        selectedItems: this.state.selectedItems.deleteIn([item.get('id')])
      });
    }

    return this.setState({
      selectedItems: this.state.selectedItems.set(item.get('id'), item)
    });
  }

  renderBatchActionControls() {
    return (
      <BatchActionsControls
        list={this.props.list}
        selectedItems={this.state.selectedItems}
        updateAll={this.updateAll} />
    );
  }

  renderBatchActionsToolbar() {
    return (
      <BatchActionsToolbar
        actionIsLoading={this.props.actionIsLoading}
        handleClear={() => this.updateAll(false)}
        renderActionsMenu={this.props.renderActionsMenu}
        totalItems={this.props.totalItems}
        globalMessaging={this.props.globalMessaging}
        messagingActions={this.props.messagingActions}
        selectedItems={this.state.selectedItems} />
    );
  }

  render() {
    return (
      <div className="cp-batch-actions-list">
        {this.renderBatchActionControls()}
        {this.props.children(this.state.selectedItems, this.updateItem)}
        {this.renderBatchActionsToolbar()}
      </div>
    );
  }
}

BatchActionsList.propTypes = {
  actionIsLoading: PropTypes.bool,
  list: ImmutablePropTypes.list.isRequired,
  pageNumber: PropTypes.number,
  pageLimit: PropTypes.number,
  totalItems: PropTypes.number.isRequired,
  renderActionsMenu: PropTypes.func.isRequired,
  globalMessaging: ImmutablePropTypes.map,
  children: PropTypes.func.isRequired,
  messagingActions: PropTypes.objectOf(PropTypes.func).isRequired
};



// WEBPACK FOOTER //
// ./app/components/shared/BatchActions/BatchActionsList/BatchActionsList.jsx